module.exports = __webpack_public_path__ + "img/max6.7c48637d.jpg";